import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "src/environments";

@Injectable()
export class ListCascadeService {
    filterSearch: BehaviorSubject<string> = new BehaviorSubject("");

    constructor(private _http: HttpClient) {}

    /**
     * Get lists
     * @returns
     */
    getListCascades(): Observable<any> {
        return this._http.get(`${environment.pimUrl}/listcascades.json`);
    }

    /**
     * Get list by id
     * @param id
     * @returns
     */
    getListCascade(id: number): Observable<any> {
        return this._http.get(`${environment.pimUrl}/listcascade/${id}.json`);
    }

    /**
     * Create new List cascade
     * @param listName
     * @param modelName
     * @returns
     */
    createListCascade(listName: string, modelId: string): Observable<{ id: number }> {
        const formData = new FormData();
        formData.append("name", listName);
        formData.append("model", modelId);
        return this._http.post<{ id: number }>(`${environment.pimUrl}/listcascade/create.json`, formData);
    }

    updateListCascade(id: number, listValues: any, lastId: number, name: string, model) {
        return this._http.post<any>(`${environment.pimUrl}/listcascade/${id}.json`, {
            listValues: listValues,
            lastId: lastId,
            name: name,
            model: model ? +model : null,
        });
    }

    deleteListCascade(id: number) {
        return this._http.delete<any>(`${environment.pimUrl}/listcascade/${id}.json`);
    }

    importFromFile(file: any) {
        return this._http.post(`${environment.pimUrl}/import/listcascade.json`, file);
    }
}
